import * as React from 'react';
import { useCopilotChat_unstable } from './useCopilotChat';
import { renderCopilotChat_unstable } from './renderCopilotChat';
import { useCopilotChatStyles_unstable } from './useCopilotChatStyles';
// CopilotChat component - TODO: add more docs
export const CopilotChat = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotChat_unstable(props, ref);
  useCopilotChatStyles_unstable(state);
  return renderCopilotChat_unstable(state);
});
CopilotChat.displayName = 'CopilotChat';
//# sourceMappingURL=CopilotChat.js.map